interface AdhocQueryDefinition {
  result?: unknown[];
}

interface ResolveAdhocQueryRecordCountOptions {
  adhocQueries?: AdhocQueryDefinition[] | null;
  isDetailedExecutionDataAvailable?: boolean;
  summaryTotal?: number | null;
  paginatedTotal?: number | null;
}

const isValidCount = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value) && value >= 0;

/**
 * Resolves the number of adhoc-query result records from already-loaded
 * dashboard data. Never counts query definitions as records.
 */
export const resolveAdhocQueryRecordCount = ({
  adhocQueries,
  isDetailedExecutionDataAvailable,
  summaryTotal,
  paginatedTotal,
}: ResolveAdhocQueryRecordCountOptions): number | null => {
  if (!Array.isArray(adhocQueries)) {
    if (isValidCount(summaryTotal)) return summaryTotal;
    if (isValidCount(paginatedTotal)) return paginatedTotal;
    return null;
  }

  const hasEmbeddedResults = adhocQueries.some((query) =>
    Array.isArray(query?.result),
  );

  if (isDetailedExecutionDataAvailable || hasEmbeddedResults) {
    return adhocQueries.reduce(
      (total, query) =>
        total + (Array.isArray(query?.result) ? query.result.length : 0),
      0,
    );
  }

  if (isValidCount(summaryTotal)) return summaryTotal;
  if (isValidCount(paginatedTotal)) return paginatedTotal;
  return null;
};
